'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getThreads = undefined;

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getThreads = exports.getThreads = (0, _getIn2.default)(['conversations', 'conversationsMap']);


//////////////////
// WEBPACK FOOTER
// ./js/threads/selectors/getThreads.js
// module id = 142
// module chunks = 2 3